import React from 'react';
import { Outlet } from 'react-router-dom';

// Padded content wrapper for legacy / ported pages.
//
// The old DashboardLayout wrapped every page in a Bootstrap `.container`, which
// supplied the side padding. The new BugZeroLayout doesn't, so legacy pages
// (which render bare) would otherwise sit edge-to-edge. This nested layout
// route gives them the standard page padding in one place.
//
// New design pages (Platform Home, Prevent dashboard, Predict, Platform
// Settings) manage their own layout/padding and are routed OUTSIDE this
// wrapper.
const PageContent = () => (
  <div className="bz-page">
    <Outlet />
  </div>
);

export default PageContent;
